import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MobileDocumentViewerService {
  private _isMobileDocumentViewerOpen = signal(false);

  isMobileDocumentViewerOpen = this._isMobileDocumentViewerOpen.asReadonly();

  setOpen(isOpen: boolean): void {
    this._isMobileDocumentViewerOpen.set(isOpen);
  }
}
